import defaultStyles from "./DefaultClickMessage.module.css";
import { htmlToReactDangerousInnerHTML } from "../../util/general";
import clsx from "clsx";

export function HotspotClickMessageBox(props) {
  // In normal operation elements of this component must use
  // class names that are used by Sirv.js. When used in the
  // theme picker they must
  // a) be insensitive to non-default class definitions
  // b) use styles provided by the theme
  // Therefore we provide an option to use default class definitions
  // and controls to add style
  const {
    style,
    onClick,
    innerHTML,
    showClose = true,
    forceDefaultClasses = false,
    elementStyles,
    className,
  } = props;
  const box = forceDefaultClasses
    ? defaultStyles.box
    : clsx("sirv-hotspot-box", className);
  const wrapper = forceDefaultClasses
    ? defaultStyles.wrapper
    : "sirv-hotspot-box-wrapper";
  const content = forceDefaultClasses
    ? defaultStyles.content
    : "sirv-hotspot-box-content";
  const closeButton = forceDefaultClasses
    ? defaultStyles.closeButton
    : "sirv-hotspot-close-button";

  return (
    <div
      draggable="false"
      className={box}
      style={{ ...elementStyles?.box, ...style }}
    >
      <div className={wrapper} style={elementStyles?.wrapper}>
        {showClose && (
          <div
            className={closeButton}
            onClick={onClick}
            style={elementStyles?.closeButton}
          />
        )}
        <div
          className={content}
          style={elementStyles?.content}
          dangerouslySetInnerHTML={htmlToReactDangerousInnerHTML(innerHTML)}
        />
      </div>
    </div>
  );
}
